export type FileWithPreview = {
    preview: string,
} & File;

export const base64ToFile = (base64: string): File => {
    if (!base64.startsWith('data:')) {
        throw new Error('Invalid Base64 string');
    }

    const mimeType = base64.split(';')[0].split(':')[1];
    const bytes = base64.split(',')[1];

    const timestamp = new Date().getTime();
    const extension = mimeType.split('/')[1];
    const fileName = `file_${timestamp}.${extension}`;

    let byteString;
    try {
        byteString = atob(bytes);
    } catch (error) {
        throw new Error(`Failed to decode base64 string ${error}`);
    }

    const byteArray = Uint8Array.from(byteString, c => c.charCodeAt(0));

    const blob = new Blob([byteArray], {type: mimeType});
    const file = new File([blob], fileName, {type: mimeType}) as FileWithPreview;

    file.preview = URL.createObjectURL(blob);

    return file;
};
